import Lang from "lang.js";
import axios from "./services/axios";

import baseSource from "../lang/langs.js";

const lang = new Lang({
	locale: window.locale || "pt",
	fallback: window.fallback || "pt",
	messages: baseSource,
});

export const fetchFromLocalStoreOrServer = async () => {
	// O cache 'source' em localStorage deixou de ser escrito; só sobrevivem caches
	// ANTIGOS que mascaravam traduções novas indefinidamente (ex.: loading.steps a
	// devolver {} e a partir o AssistantLoading). Purgamos para não sobrepor o bundle.
	try {
		localStorage.removeItem("source");
		localStorage.removeItem("locale");
		localStorage.removeItem("fallback");
	} catch (e) {
		// localStorage indisponível — segue com o bundle
	}

	// O bundle (baseSource) já cobre as traduções offline; online buscamos as atuais
	// (podem ter sido editadas no servidor sem novo deploy). Falha = fica com o bundle.
	if (typeof navigator === "undefined" || navigator.onLine) {
		try {
			await updateContentFromServer();
		} catch (e) {
			// offline/erro — o bundle (baseSource) cobre as traduções
		}
	}

	return lang;
};

export const updateContentFromServer = async () => {
	try {
		const {
			data: { source },
		} = await axios.get("/api/fetch-source-translator", {
			params: {
				locale: window.locale,
			},
		});
		lang.setMessages(source);
		return Promise.resolve(source);
	} catch (e) {
		console.error("Error fetch content for translator", e);
		return Promise.reject(e);
	}
};

window.lang = lang;
export default { lang, updateContentFromServer, fetchFromLocalStoreOrServer };
